import { RootSelector, getStore } from '../../reducers';
import { ViewerShape } from './model';
import { createSelector } from '@reduxjs/toolkit';
import { Loading } from '../finder/model';

export const getViewer: RootSelector<ViewerShape> = createSelector(
  getStore,
  (state) => state.viewer,
);

export const getData: RootSelector<ViewerShape['data']> = createSelector(
  getViewer,
  (viewer) => viewer.data,
);

export const getLoading: RootSelector<Loading> = createSelector(
  getViewer,
  (viewer) => viewer.loading,
);

export const getHasNextPage: RootSelector<boolean> = createSelector(
  getViewer,
  (viewer) => viewer.hasNextPage,
);

export const getScrollHash: RootSelector<string> = createSelector(
  getViewer,
  (viewer) => viewer.scrollHash,
);

export const getCreative: RootSelector<ViewerShape['creative']> = createSelector(
  getViewer,
  (viewer) => viewer.creative,
);

export const getCache: RootSelector<ViewerShape['cache']> = createSelector(
  getViewer,
  (viewer) => viewer.cache,
);
